import InfoSection from '../components/info_section';
import ScrollButton from '../components/scroll_button';
import { allToolsList, cloudServicesList } from '../constants/location-admin';
import Layout from '../components/layout';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import styles from '../styles/location-admin.module.scss';
import ContactUsModal from '../components/contactUsModal';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import arrowUp from "../svgs/locationAdmin/arrow-up.svg"
import arrowDown from "../svgs/locationAdmin/arrow-down.svg"
import Image from 'next/image';

export default function LocationAdmin() {
  const router = useRouter();
  const { t } = useTranslation('locationAdmin');
  const [toolFlag, setToolFlag] = useState('accountManagement');
  const [hidden, setHidden] = useState('');

  useEffect(() => {
    setHidden('')
  }, [toolFlag]);

  const arrows = {
    up: arrowUp,
    down: arrowDown
  };

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
        <ScrollButton scrollStepInPx='50' delayInMs='16.66' />
        <InfoSection title='Location Admin' description='locationAdminDescription' documentationLink='https://help.icdc.io/admin/' lang={router.locale} />

        <div className={styles.runYourCloud}>
          <div>
            <h2>{t('runYourCloud.title')}</h2>
            <p>{t('runYourCloud.description1')}</p>
          </div>
          <div>
          <Image src='/locationAdminRun.webp' alt='Run your own cloud business' loading='lazy' width={734} height={447} unoptimized />
          </div>
        </div>

        <section className={styles.allTools}>
            <h2>{t('allTheTools.title')}</h2>

            <div className={styles.allTools__tools}>
              <div className={styles.tabs__container}>
                <div className={styles.tabs}>
                  {allToolsList.map((tool, index) => (
                  <div 
                    key={index} 
                    className={ toolFlag === tool.flag ? styles.active : ''}
                    onClick={() => {toolFlag !== tool.flag && setHidden('fogs');
                    setTimeout(() =>  setToolFlag(tool.flag), 300)
                    }}
                  >
                    <tool.icon />
                    <p>{t(tool.title)}</p>
                  </div>))}
                </div>
              </div>

              <div className={styles.contentWrapper}>
                <div className={styles.fog} style={hidden !== ''? {opacity: '1', visibility:'visible'} : {}}></div>
                {allToolsList.map((tool, index) => toolFlag === tool.flag && (
                  <div key={index} className={styles.content}>
                    <Image src={t(tool.imgUrl)} alt={tool.title} loading='lazy' width={787} height={334} unoptimized />
                    <div>
                      <h3>{t(tool.title)}</h3>
                      <p dangerouslySetInnerHTML={
                        {__html: t(tool.description, { interpolation: { escapeValue: false }})}
                      } />
                      {tool.docsUrl && <Link href={t(tool.docsUrl)}>
                        <a>
                          <button className={'btn outlined'}>{t('readDocs')}</button>
                        </a>
                      </Link>}
                    </div>
                  </div>))}
              </div>
            </div>
            <div className={styles.allTools__tools_mobile}>
              <div className={styles.tabs}>
                {allToolsList.map((tool, index) => (
                <div key={index} className={styles.tab_mobile}>
                <div 
                  className={ toolFlag === tool.flag ? styles.active : ''}
                  onClick={() => setToolFlag(tool.flag)}
                >
                  {/* <Image src={tool.icon} layout='fixed' /> */}
                  <tool.icon />
                  <p>{t(tool.title)}</p>
                      <Image src={toolFlag === tool.flag ? arrows.up : arrows.down} layout='fixed' alt={t("expandCollapseAlt")} />
                  {/* { toolFlag === tool.flag 
                  ? <arrows.up /> 
                  : <arrows.down />} */}
                </div>
                {toolFlag === tool.flag && 
                  <div key={index} className={styles.content_mobile}>

                        <h3>{t(tool.title)}</h3>
                        <p dangerouslySetInnerHTML={
                        {__html: t(tool.description, { interpolation: { escapeValue: false }})}
                        } />
                        <Link href={t(tool.docsUrl)}>
                          <a>
                            <button className={'btn outlined'}>{t('readDocs')}</button>
                          </a>
                        </Link>
       
                        <img src={t(tool.imgUrl)} alt={tool.title || ''} />
                </div>}
                </div>))}
              </div>
            </div> 

        </section>

        <section className={styles.automate}>
          <div className='flex'>
            <h3>{t('automate.title')}</h3>
            <p>{t('automate.description')}</p>
        <ContactUsModal blue />
          </div>
        </section>

        <section className={styles.cloudServices}>
        <h2>{t('cloudServices.title')}</h2>
            <div className={styles.cloudServices__list}>
              { cloudServicesList.map((service, index) => (
                <Link href={service.url} key={index}>
                    <div key={index}>
                    <Image src={service.img} layout='fixed' alt="" />
                    <h3>{t(service.subtitle)}</h3>
                      <p>{t(service.subdescription)}</p>
                    </div>
                </Link>
              ))}
            </div>
        </section>

      
    </Layout>
  )
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['locationAdmin', 'common']),
  },
});
